import styled from "styled-components";
import { DESKTOP, MEDIUM_DESKTOP } from "../../../../../styles/breakpoints";

export const OnboardingLayoutContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  background-color: #fff;
`;

export const OnboardingLayoutContent = styled.div`
  width: 90%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: start;

  @media screen and (min-width: ${DESKTOP}) {
    width: 50%;
    padding: 4rem;
  }
`;

export const TalentLogo = styled.img`
  position: absolute;
  top: 2rem;
  left: 2rem;
`;

export const OnboardingLayoutImage = styled.div`
  background-image: url(
    "https://talentdio.s3.sa-east-1.amazonaws.com/assets/img/cover_talent.png");
  height: 100vh;
  width: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 90% auto;
  @media screen and (min-width: ${MEDIUM_DESKTOP}) {
    background-size: 70% auto;
  }
`;
